var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "record-create-success" }, [
    _c("div", { staticClass: "header" }, [
      _c("h1", [_vm._v("Auftragserfassung")]),
      _vm._v(" "),
      _vm.record.id
        ? _c(
            "div",
            { staticClass: "record-details" },
            [
              _c("p", { staticClass: "mb-1" }, [
                _c("b", [_vm._v("Akte:")]),
                _vm._v(
                  " " +
                    _vm._s(_vm.record.attributes.referenceNumber) +
                    "\n            "
                ),
              ]),
              _vm._v(" "),
              _c("csp-record-customer-vehicle-info", {
                attrs: {
                  "claim-type": _vm.record.attributes.claimType,
                  "claim-type-comprehensive":
                    _vm.record.attributes.claimTypeComprehensive,
                  "claim-type-delivery":
                    _vm.record.attributes.claimTypeDelivery,
                  "customer-attributes": _vm.customer.attributes,
                  "is-first-party-damage":
                    _vm.record.attributes.isFirstPartyDamage,
                  "vehicle-attributes": _vm.vehicle.attributes,
                },
              }),
            ],
            1
          )
        : _vm._e(),
    ]),
    _vm._v(" "),
    _vm.record.id
      ? _c("div", { staticClass: "success-body text-center" }, [
          _c("i", {
            staticClass: "inticon-completed-circle mb-5 text-secondary",
            staticStyle: { "font-size": "92px" },
          }),
          _vm._v(" "),
          _c("h3", [_vm._v("Akte wurde erfolgreich angelegt")]),
          _vm._v(" "),
          _c("div", { staticClass: "success-body-description mt-3" }, [
            !_vm.isDebtCollectionClaim
              ? _c(
                  "p",
                  [
                    _vm._v(
                      "\n                Der Vorgang wurde Ihren Schadenakten hinzugefügt.\n                Sie werden nun automatisch in die\n                "
                    ),
                    _vm.isDeliveryClaim
                      ? [
                          _vm._v(
                            "\n                    detailliertere Schadensbeschreibung\n                "
                          ),
                        ]
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.isRegressClaim
                      ? [
                          _vm._v(
                            "\n                    Zusammenfassung\n                "
                          ),
                        ]
                      : [
                          _vm._v(
                            "\n                    detailliertere Unfalldokumentation\n                "
                          ),
                        ],
                    _vm._v("\n                weitergeleitet.\n            "),
                  ],
                  2
                )
              : _vm._e(),
            _vm._v(" "),
            _vm.isDebtCollectionClaim
              ? _c("p", [
                  _vm._v(
                    "\n                Der Vorgang wurde Ihren Schadenakten hinzugefügt.\n                Sie werden nun automatisch zur weiteren Kundendateneingabe weitergeleitet.\n            "
                  ),
                ])
              : _vm._e(),
          ]),
        ])
      : _vm._e(),
    _vm._v(" "),
    !_vm.record.id
      ? _c(
          "div",
          { staticClass: "d-flex justify-content-center py-3 mb-0" },
          [_c("csp-loading-indicator")],
          1
        )
      : _vm._e(),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }